export default {
	primary_orange: "#D87D0F",
	primary_blue: "#4D9BA6",
	secondary_blue: "#052D3E",
	primary_background: "#F4C127",
	primary_text_background: "#FFF",
	primary_text_color: "#000",
	positive: "#3e9408",
	negative: "#BF2A2A",
};



// WEBPACK FOOTER //
// ../shared/theme.js